import { Button } from '@carbon/react';
import { TrashCan } from '@carbon/icons-react';
import { TextInput } from '@mantine/core';
import { ChangeEvent } from 'react';
import { useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';
import styles from './EventTitleInput.module.scss';

type Props = {
    onDeleteRequest?: () => void;
    canDelete?: boolean;
    disabled?: boolean;
};

const EventTitleInput = ({
    onDeleteRequest,
    canDelete,
    disabled,
}: Props) => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { title } = values;

    const updateTitle = (evt: ChangeEvent<HTMLInputElement>) => {
        updateValues({
            ...values,
            title: evt.target.value,
        });
    };

    const label = intl.formatMessage(sharedMessages.title);

    return (
        <div className={styles.container}>
            <TextInput
                id="event-title-input"
                label={label}
                placeholder={intl.formatMessage(sharedMessages.titlePlaceholder)}
                form="event-handler-form"
                type="text"
                maxLength={254}
                onChange={updateTitle}
                value={title}
                disabled={disabled}
                required
                title={label}
                radius="md"
                size="md"
            />
            {canDelete && (
                <Button
                    type="button"
                    kind="ghost"
                    hasIconOnly
                    renderIcon={TrashCan}
                    iconDescription={intl.formatMessage(sharedMessages.remove)}
                    tooltipPosition="left"
                    className={styles.deleteButton}
                    onClick={onDeleteRequest}
                />
            )}
        </div>
    );
};

export default EventTitleInput;
